
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaches",
      function () {
        return require("private-next-pages/coaches/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaches"])
      });
    }
  